import type { ServerInfo } from '@/utils/connectionKeyUtils';
import { invoke } from '@tauri-apps/api/core';
import { atom } from 'nanostores';

export const $serverState = atom<ServerInfo | undefined>(undefined);

export function setServerState(serverState: ServerInfo | undefined) {
  $serverState.set(serverState);
}

export async function syncServerState() {
  try {
    const serverInfo = await invoke<ServerInfo>('get_server_info');
    $serverState.set(serverInfo);
  } catch {
    $serverState.set(undefined);
  }
}
